// assets/cart-drawer.js

class CartDrawerItems extends HTMLElement {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".cart-drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }



  renderContents(parsedState) {
    // Update cart items list
    this.classList.toggle("is-empty", parsedState.items.length === 0);
    if (parsedState.sections && parsedState.sections["cart-drawer"]) {
      const cartItemsList = this.querySelector(".cart-items");
      if (cartItemsList) {
        cartItemsList.innerHTML = new DOMParser()
          .parseFromString(parsedState.sections["cart-drawer"], "text/html")
          .querySelector(".cart-items").innerHTML;
        cartItemsList.classList.toggle(
          "is-empty",
          parsedState.items.length === 0
        );
      }
    }
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    // Escape key to close drawer
    this.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") {
        this.close();
      }
    });

    // Overlay click to close drawer
    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.addEventListener("click", this.close.bind(this));
    }

    // Close button
    const closeButton = this.querySelector(".drawer__close");
    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    const shouldBlockDrawer = () => this.shouldBlockDrawer();
    cartLink.addEventListener("click", (event) => {
      if (shouldBlockDrawer()) {
        return;
      }
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (shouldBlockDrawer()) {
        return;
      }
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  shouldBlockDrawer() {
    const path = window.location.pathname;
    return (
      path === "/cart" ||
      /^\/[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\/cart$/.test(path)
    );
  }
  open(triggeredBy) {
    if (this.shouldBlockDrawer()) {
      return;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }
    this.classList.add("animate", "active");
    this.style.display = "block";
    this.style.visibility = "visible";

    const cartDrawerInner = this.querySelector("#CartDrawer");
    if (cartDrawerInner) {
      cartDrawerInner.style.transform = "translateX(0)";
      cartDrawerInner.style.right = "0";
    }

    const cartInnerContent = this.querySelector(".cart-drawer__inner");
    if (cartInnerContent) {
      cartInnerContent.style.display = "flex";
      cartInnerContent.style.visibility = "visible";
      cartInnerContent.style.position = "relative";
      cartInnerContent.style.right = "0";
    }

    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.classList.add("active");
      overlay.style.display = "block";
      overlay.style.opacity = "1";
      overlay.style.zIndex = "49";
    }

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active", "animate");
    this.style.display = "none";
    this.style.visibility = "hidden";

    const cartDrawerInner = this.querySelector("#CartDrawer");
    if (cartDrawerInner) {
      cartDrawerInner.style.transform = "translateX(100%)";
    }

    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.classList.remove("active");
      overlay.style.display = "none";
    }

    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }
    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });
    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState, autoOpen = true) {
    if (
      !parsedState ||
      !parsedState.items ||
      !parsedState.sections ||
      parsedState.total_price === undefined ||
      parsedState.total_price === null ||
      isNaN(parsedState.total_price)
    ) {
      console.warn("Invalid parsedState in renderContents:", parsedState);
      return;
    }
    //updateCustomerCartMetafield();
    this.classList.toggle("is-empty", parsedState.items.length === 0);
    const drawerInnerEmpty = this.querySelector(".drawer__inner-empty");
    if (drawerInnerEmpty) {
      drawerInnerEmpty.classList.toggle("hidden", parsedState.items.length > 0);
    }
    const cartFooter = this.querySelector(".cart-drawer__footer");
    if (cartFooter) {
      cartFooter.classList.toggle("hidden", parsedState.items.length === 0);
    }
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");
    if (
      cartDrawerInner &&
      parsedState.sections &&
      parsedState.sections["cart-drawer"]
    ) {
      const parser = new DOMParser();
      const newContent = parser.parseFromString(
        parsedState.sections["cart-drawer"],
        "text/html"
      );

      const newInner = newContent.querySelector(".cart-drawer__inner");

      if (newInner) {
        cartDrawerInner.innerHTML = newInner.innerHTML;
        refreshModalCartDrawerItems();
      } else {
        console.error("Failed to find .cart-drawer__inner in parsed sections");
      }
    } else {
      console.error("cart-drawer__inner or sections not found:", {
        cartDrawerInner,
        sections: parsedState.sections,
      });
    }

    const totalPrice = parsedState.total_price;
    const totalsElement = this.querySelector(".totals_drawer p:last-child");
    if (totalsElement && totalPrice !== undefined) {
      totalsElement.textContent =
        "Rp" +
        (totalPrice / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    const bubble = document.querySelector("#cart-icon-bubble");
    if (bubble && parsedState.sections["cart-icon-bubble"]) {
      bubble.innerHTML = new DOMParser()
        .parseFromString(parsedState.sections["cart-icon-bubble"], "text/html")
        .querySelector(".shopify-section").innerHTML;
    }

    const cartItemsElement = this.querySelector("cart-items");
    if (
      cartItemsElement &&
      typeof cartItemsElement.renderContents === "function"
    ) {
      cartItemsElement.renderContents(parsedState);
    }

    // if (autoOpen && !this.shouldBlockDrawer()) {
    //   if (parsedState.items.length > 0) {
    //     console.log("Auto-opening cart drawer");
    //     this.open();
    //   }
    // }

    if (autoOpen && !this.shouldBlockDrawer()) {
      this.open(); // always open, empty or not
    }
  }
}



customElements.define("cart-drawer", CartDrawer);
customElements.define("cart-drawer-items", CartDrawerItems);

// Locale prefix (only for English and Indonesian)
function getLocalePrefix() {
  return window.location.pathname.startsWith("/id") ? "/id" : "";
}

function getSectionsUrl() {
  return `${getLocalePrefix()}/?sections=cart-drawer,cart-icon-bubble`;
}

function getCartUrl() {
  return `${getLocalePrefix()}/cart`;
}

// Fallback stubs for dependencies
function trapFocus(container, elementToFocus) {
  if (!container || !elementToFocus) return;
  const focusableElements = container.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  elementToFocus = elementToFocus || firstElement;
  elementToFocus.focus();
  container.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  });
}

function removeTrapFocus(elementToFocus) {
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
function refreshModalCartDrawerItems() {
  fetch("/?sections=cart-drawer")
    .then((res) => res.json())
    .then((data) => {
      const html = data["cart-drawer"];

      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, "text/html");
      const newContent = newDoc.getElementById("ModalCartDrawerItems");

      const target = document.getElementById("ModalCartDrawerItems");
      if (target && newContent) {
        target.innerHTML = newContent.innerHTML;
      }
    })
    .catch((err) =>
      console.error("Failed to refresh ModalCartDrawerItems:", err)
    );
}

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    const observer = new MutationObserver(() => {
      if (drawer.classList.contains("active")) {
        document.body.classList.add("drawer-open");
      } else {
        document.body.classList.remove("drawer-open");
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }
  fetch("/cart.js")
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
      return res.json();
    })
    .then((cart) => {
      //updateCustomerCartMetafield();
      return fetch(getSectionsUrl()).then((res) => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return Promise.all([res.json(), Promise.resolve(cart)]);
      });
    })
    .then(([sections, cart]) => {
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(
          {
            items: cart.items,
            sections,
            total_price: cart.total_price,
          },
          false
        );
      } else {
        console.error("cart-drawer element or renderContents method not found");
      }
    })
    .catch((err) => console.error(" Initial cart fetch failed:", err));

  //Update cart item sync metafield on remove items from main cart
  cartRemoveButton();
});

// Legacy cartRemoveButton() removed — all remove handling is now done
// by the global .cart-item__remove click handler below (line ~900+).
function cartRemoveButton() {
  // No-op: kept as empty function since it's called from multiple places.
  // Main cart remove is now handled by the global delegated click handler.
}

function reindexCartItems() {
  // After removing a row, re-number the remaining CartItem IDs
  // so Shopify line numbers stay correct for subsequent removals
  const rows = document.querySelectorAll("#main-cart-items .cart-item");
  rows.forEach((row, idx) => {
    row.id = `CartItem-${idx + 1}`;
  });
}

let pendingMainCartRefresh = null;

function scheduleMainCartRefresh() {
  if (pendingMainCartRefresh) clearTimeout(pendingMainCartRefresh);
  pendingMainCartRefresh = setTimeout(async () => {
    pendingMainCartRefresh = null;

    // Wait for any in-flight flush to complete before reading cart state
    while (cartDrawerFlushInFlight || cartDrawerPendingUpdates.size > 0) {
      await new Promise((r) => setTimeout(r, 100));
    }

    await updateCustomerCartMetafield();

    try {
      // Fetch updated cart data (just for totals — don't touch the items list)
      const cart = await fetch("/cart.js").then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      });

      // If cart is empty, reload to show empty state
      if (cart.item_count === 0) {
        location.reload();
        return;
      }

      // Update order summary totals
      const itemsTotal = document.getElementById("items-total");
      const promoAmount = document.getElementById("promotions-amount");
      const subtotalAmount = document.getElementById("subtotal-amount");
      if (itemsTotal) {
        const originalTotal = cart.items.reduce((sum, item) => sum + item.original_price * item.quantity, 0);
        itemsTotal.textContent = formatMoney(originalTotal);
      }
      if (promoAmount) {
        const discount = cart.total_discount || 0;
        promoAmount.textContent = discount > 0 ? "-" + formatMoney(discount) : formatMoney(0);
      }
      if (subtotalAmount) {
        subtotalAmount.textContent = formatMoney(cart.total_price);
      }

      // Update cart icon bubble silently
      const bubbleRes = await fetch("/?section_id=cart-icon-bubble");
      if (bubbleRes.ok) {
        const bubbleHtml = await bubbleRes.text();
        const bubble = document.querySelector("#cart-icon-bubble");
        if (bubble) {
          bubble.innerHTML = new DOMParser()
            .parseFromString(bubbleHtml, "text/html")
            .querySelector(".shopify-section").innerHTML;
        }
      }

      // Update greeting item count
      const itemCountEl = document.querySelector(".item-count");
      if (itemCountEl) {
        const itemWord = cart.item_count === 1 ? "item" : "items";
        itemCountEl.textContent = `(${cart.item_count} ${itemWord})`;
      }

      const orderSummaryItemCountEl = document.getElementById("order-summary-item-count");
      if (orderSummaryItemCountEl) {
        orderSummaryItemCountEl.textContent = `(${cart.item_count})`;
      }

    } catch (err) {
      console.error("Main cart refresh failed:", err);
    }
  }, 600);
}

function formatMoney(cents) {
  return "Rp" + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function optimisticUpdateMainCartUI() {
  // Update "Shopping Bag (X items)" headers
  document.querySelectorAll(".cart-shop-title, .cart__empty-text").forEach((el) => {
    const match = el.textContent.match(/\((\d+)/);
    if (match) {
      const newCount = Math.max(0, parseInt(match[1]) - 1);
      el.textContent = el.textContent.replace(
        /\(\d+/,
        `(${newCount}`
      );
    }
  });

  const orderSummaryItemCountEl = document.getElementById("order-summary-item-count");
  if (orderSummaryItemCountEl) {
    const match = orderSummaryItemCountEl.textContent.match(/\((\d+)/);
    if (match) {
      const newCount = Math.max(0, parseInt(match[1]) - 1);
      orderSummaryItemCountEl.textContent = `(${newCount})`;
    }
  }

  // Update the item count in the greeting header
  const itemCountEl = document.querySelector(".item-count");
  if (itemCountEl) {
    const match = itemCountEl.textContent.match(/\((\d+)/);
    if (match) {
      const newCount = Math.max(0, parseInt(match[1]) - 1);
      const itemWord = newCount === 1 ? "item" : "items";
      itemCountEl.textContent = `(${newCount} ${itemWord})`;
    }
  }
}

async function updateCustomerCartMetafield(currentCart = null) {
  if (!window?.customer?.id) return; // Only run for logged-in users

  if (!currentCart) {
    currentCart = await fetch(`${routes.cart_url}.js`).then((res) => res.json());
  }

  const cartData = {
    items: currentCart?.items.map((item) => ({
      variant_id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties || {},
    })),
    attributes: currentCart.attributes || {},
    note: currentCart.note || "",
  };

  try {
    const metaUpdateRes = await window.mapclubFetch('customer-cart-data', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: window.customer.id,
        cartData,
      }),
    });
    const data = await metaUpdateRes.json();
    const newItemsData = data?.metafield?.value
      ? data.metafield.value
      : window.customer?.metafields?.cart?.itemsdata;

    window.customer = {
      ...window.customer,
      metafields: {
        ...window.customer?.metafields,
        cart: {
          ...window.customer?.metafields?.cart,
          itemsdata: newItemsData,
        },
      },
    };
  } catch (err) {
    console.error('Failed to update customer cart metafield:', err);
  }
}

const cartDrawerOptimisticQuantities = new Map();
let cartDrawerOptimisticTotalPrice = null;
const cartDrawerPendingUpdates = new Map();
let cartDrawerFlushTimer = null;
let cartDrawerFlushInFlight = false;
let cartDrawerFlushQueued = false;
let cartDrawerLastServerState = null;
const CART_DRAWER_REMOVE_FLUSH_DELAY = 120;

// Consolidated: use formatMoney() for all money formatting
function formatDrawerMoneyFromCents(cents) {
  return formatMoney(Math.max(0, Number(cents) || 0));
}

function parseDisplayedMoneyToCents(text) {
  const digits = String(text || "").replace(/[^\d]/g, "");
  if (!digits) return 0;
  return parseInt(digits, 10) * 100;
}

function getCartDrawerTotalPriceCents() {
  const totalElement = document.querySelector(
    "cart-drawer .totals_drawer p:last-child"
  );
  return parseDisplayedMoneyToCents(totalElement?.textContent);
}

function getCartDrawerLinePriceCents(cartItem) {
  if (!cartItem) return 0;

  const selectors = [
    ".price-item--sale",
    ".price-item--regular",
    ".money",
    ".cart-item__price",
  ];

  for (const selector of selectors) {
    const cents = parseDisplayedMoneyToCents(
      cartItem.querySelector(selector)?.textContent
    );
    if (cents > 0) {
      return cents;
    }
  }

  return 0;
}

function getCartDrawerFreeShippingThresholdCents() {
  const progressContainer = document.querySelector(
    "cart-drawer .free-shipping-progress"
  );
  return Number(progressContainer?.dataset.freeShippingThreshold || 0);
}

function updateDrawerItemCount(delta) {
  if (!delta) return;

  const drawerCount = document.querySelector("cart-drawer .cart-drawer__item-count");
  let nextCount = 0;

  if (drawerCount) {
    const currentCount = parseInt(drawerCount.dataset.count || "0", 10);
    nextCount = Math.max(0, currentCount + delta);
    drawerCount.dataset.count = String(nextCount);

    const singularLabel = drawerCount.dataset.labelOne || "1 item";
    const pluralTemplate = drawerCount.dataset.labelOther || "2 items";
    drawerCount.textContent =
      nextCount === 1
        ? singularLabel.replace(/\d+/, String(nextCount))
        : pluralTemplate.replace(/\d+/, String(nextCount));
  } else {
    const drawerTitle = document.querySelector("cart-drawer .drawer__header h2");
    if (drawerTitle) {
      drawerTitle.textContent = drawerTitle.textContent.replace(
        /\((\d+)(?:\s+[^\)]*)?\)\s*$/,
        (_, count) => {
          nextCount = Math.max(0, parseInt(count, 10) + delta);
          return `(${nextCount})`;
        }
      );
    }
  }

  const bubble = document.querySelector("#cart-icon-bubble .cart-count-bubble");
  const bubbleText = bubble?.querySelector('span[aria-hidden="true"]');
  if (bubbleText) {
    const currentBubbleCount = parseInt(bubbleText.textContent.replace(/\D/g, ""), 10);
    const bubbleCount = Number.isFinite(currentBubbleCount)
      ? Math.max(0, currentBubbleCount + delta)
      : nextCount;
    bubbleText.textContent = bubbleCount;
    bubble.classList.toggle("hidden", bubbleCount <= 0);
  }
}

function updateCartDrawerSummary(totalCents) {
  const normalizedTotal = Math.max(0, Number(totalCents) || 0);
  const totalElement = document.querySelector("cart-drawer .totals_drawer p:last-child");
  if (totalElement) {
    totalElement.textContent = formatDrawerMoneyFromCents(normalizedTotal);
  }

  const freeShippingThreshold = getCartDrawerFreeShippingThresholdCents();
  const progressFill = document.querySelector("cart-drawer .progress-bar__fill");
  if (progressFill && freeShippingThreshold > 0) {
    const progress = Math.min(100, (normalizedTotal / freeShippingThreshold) * 100);
    progressFill.style.width = `${progress}%`;
  }

  const progressText = document.querySelector("cart-drawer .progress-text");
  if (progressText && freeShippingThreshold > 0) {
    const achievedText =
      progressText.dataset.freeShippingAchieved ||
      "Congratulations! You have qualified for free shipping";
    const achievedBoldText =
      progressText.dataset.freeShippingAchievedBold || "FREE Shipping";
    const freeShippingMoreText =
      progressText.dataset.freeShippingMore || "more for";
    const freeShippingBoldText =
      progressText.dataset.freeShippingBold || "FREE Shipping";
    const addRpText = progressText.dataset.addRp || "Add Rp";

    if (normalizedTotal >= freeShippingThreshold) {
      progressText.innerHTML = `${achievedText} <strong>${achievedBoldText}</strong>`;
    } else {
      const remaining = freeShippingThreshold - normalizedTotal;
      const formattedRemaining = formatDrawerMoneyFromCents(remaining).replace(
        "Rp",
        ""
      );
      progressText.innerHTML =
        `${addRpText}${formattedRemaining}&nbsp;${freeShippingMoreText} ` +
        `<strong>${freeShippingBoldText}</strong>`;
    }
  }
}

function animateDrawerItemRemoval(cartItem) {
  if (!cartItem) return;

  cartItem.style.maxHeight = `${cartItem.scrollHeight}px`;
  cartItem.style.pointerEvents = "none";
  cartItem.offsetHeight;
  cartItem.classList.add("removing");
}

function syncCartDrawerLineQuantity(key, quantity) {
  // Sync quantity on all remove buttons with this key (drawer + main cart)
  document
    .querySelectorAll(
      `.cart-item__remove[data-key="${CSS.escape(key)}"]`
    )
    .forEach((button) => {
      button.dataset.currentQuantity = String(quantity);
    });
}

function scheduleCartDrawerFlush(immediate = false) {
  if (cartDrawerFlushTimer) {
    clearTimeout(cartDrawerFlushTimer);
  }

  if (immediate) {
    flushCartDrawerUpdates();
    return;
  }

  cartDrawerFlushTimer = setTimeout(() => {
    cartDrawerFlushTimer = null;
    flushCartDrawerUpdates();
  }, CART_DRAWER_REMOVE_FLUSH_DELAY);
}

async function flushCartDrawerUpdates() {
  if (cartDrawerFlushInFlight || cartDrawerPendingUpdates.size === 0) {
    if (cartDrawerFlushInFlight) {
      cartDrawerFlushQueued = true;
    }
    return;
  }

  cartDrawerFlushInFlight = true;
  cartDrawerFlushQueued = false;

  const cartDrawer = document.querySelector("cart-drawer");
  const updates = {};
  cartDrawerPendingUpdates.forEach((quantity, key) => {
    updates[key] = quantity;
  });
  cartDrawerPendingUpdates.clear();

  try {
    const res = await fetch(`${getLocalePrefix()}/cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates,
        sections: "cart-drawer,cart-icon-bubble",
        sections_url: window.location.pathname,
      }),
    });

    if (!res.ok) {
      throw new Error(`Cart update failed (HTTP ${res.status})`);
    }

    const parsedState = await res.json();
    if (!parsedState || !parsedState.sections || !Array.isArray(parsedState.items)) {
      throw new Error("Cart update returned an invalid payload");
    }

    cartDrawerLastServerState = parsedState;

    if (
      cartDrawerPendingUpdates.size === 0 &&
      !cartDrawerFlushQueued &&
      cartDrawer &&
      typeof cartDrawer.renderContents === "function"
    ) {
      try {
        cartDrawer.renderContents(cartDrawerLastServerState, false);
      } catch (renderErr) {
        // Non-fatal: drawer re-render may fail on non-drawer pages (e.g. main cart)
      }
      cartDrawerOptimisticQuantities.clear();
      cartDrawerOptimisticTotalPrice = null;
    }

    await updateCustomerCartMetafield();

    // If cart is empty on main cart page, reload to show empty state
    if (parsedState.items.length === 0 && document.getElementById('main-cart-items')) {
      location.reload();
      return;
    }
  } catch (err) {
    console.error("Cart drawer remove failed:", err);
    cartDrawerOptimisticQuantities.clear();
    cartDrawerOptimisticTotalPrice = null;
    cartDrawerPendingUpdates.clear();
    window.location.reload();
  } finally {
    cartDrawerFlushInFlight = false;
    if (cartDrawerPendingUpdates.size > 0 || cartDrawerFlushQueued) {
      scheduleCartDrawerFlush(true);
    }
  }
}

document.addEventListener("click", function (e) {
  const removeBtn = e.target.closest(".cart-item__remove");
  if (!removeBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const key = removeBtn.dataset.key;
  if (!key) return;

  const domQuantity = parseInt(removeBtn.dataset.currentQuantity, 10);
  const currentQuantity = cartDrawerOptimisticQuantities.has(key)
    ? cartDrawerOptimisticQuantities.get(key)
    : domQuantity;

  if (!Number.isFinite(currentQuantity) || currentQuantity <= 0) {
    return;
  }

  const nextQuantity = currentQuantity - 1;
  cartDrawerOptimisticQuantities.set(key, nextQuantity);
  syncCartDrawerLineQuantity(key, nextQuantity);

  // Support both drawer (.cart-item_drawer) and main cart (.cart-item) rows
  const cartItem = removeBtn.closest(".cart-item_drawer") || removeBtn.closest(".cart-item");
  const isMainCart = !removeBtn.closest(".cart-item_drawer") && removeBtn.closest("#main-cart-items");

  if (isMainCart && cartItem) {
    // Main cart page: animate row removal and schedule refresh
    cartItem.style.maxHeight = cartItem.scrollHeight + "px";
    cartItem.style.pointerEvents = "none";
    cartItem.offsetHeight; // force reflow
    cartItem.classList.add("removing");

    const separatorRow = cartItem.nextElementSibling;
    if (separatorRow && separatorRow.querySelector("hr")) {
      separatorRow.classList.add("cart-item-separator-removing");
    }

    optimisticUpdateMainCartUI();

    setTimeout(() => {
      if (separatorRow) separatorRow.remove();
      cartItem.remove();
      reindexCartItems();
    }, 200);
  } else {
    // Cart drawer: existing drawer-specific logic
    const linePriceCents = getCartDrawerLinePriceCents(cartItem);
    animateDrawerItemRemoval(cartItem);
    updateDrawerItemCount(-1);

    const currentTotalCents =
      cartDrawerOptimisticTotalPrice ?? getCartDrawerTotalPriceCents();
    const nextTotalCents = Math.max(0, currentTotalCents - linePriceCents);
    cartDrawerOptimisticTotalPrice = nextTotalCents;
    updateCartDrawerSummary(nextTotalCents);
  }

  cartDrawerPendingUpdates.set(key, nextQuantity);

  if (nextQuantity <= 0) {
    cartDrawerOptimisticQuantities.delete(key);
  }

  scheduleCartDrawerFlush();

  // If on main cart page, also schedule totals refresh
  if (isMainCart) {
    scheduleMainCartRefresh();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const cartIcon = document.getElementById("cart-icon-bubble");
  if (!cartIcon) return;
  cartIcon.addEventListener(
    "click",
    (event) => {
      if (window.innerWidth <= 1024) {
        event.preventDefault();
        event.stopPropagation();
        const cartUrl = getCartUrl();
        if (window.location.pathname !== cartUrl) {
          window.location.href = cartUrl;
        }
      }
    },
    true
  );
});

function updateCartCount(quantity) {
  const cartCountBubble = document.querySelector(
    "#cart-icon-bubble .cart-count-bubble"
  );
  const cartCount = document.querySelector("#cart-icon-bubble .cart-count");

  if (!cartCountBubble || !cartCount) return;

  if (quantity > 0) {
    cartCount.textContent = quantity;
    cartCountBubble.classList.remove("hidden");
  } else {
    cartCount.textContent = 0;
    cartCountBubble.classList.add("hidden");
  }
}

// Cart count is updated via renderContents and scheduleMainCartRefresh.
// No standalone fetch needed here.

// cart restore from metafield
async function restoreCartFromCustomerMetafield() {
  let addAlreadyRun = localStorage.getItem("customerCartChecked");
  if (!window?.customer?.id && addAlreadyRun) {
    localStorage.removeItem("customerCartChecked");
  }
  if (!window?.customer?.id) return;


  let cartData = typeof window.customer?.metafields?.cart?.itemsdata === "string"
    ? JSON.parse(window.customer.metafields.cart.itemsdata)
    : window.customer?.metafields?.cart?.itemsdata || {};
  if (!cartData) return;
  const currentCart = await fetch("/cart.js").then((res) => res.json());
  const currentIds = currentCart.items.map((item) => item.id);

  const savedIds = cartData.items?.map((item) => item.variant_id) || [];
  // Track if any changes were made to the cart
  let cartModified = false;
  // --- Find mismatched items ---
  const mismatchedItems = currentCart.items?.filter((item) => {
    const id = item.id;
    return !id || !savedIds.includes(id); // missing or not present in metafield data
  });

  let mismatchedIds;
  // Case 1: lengths differ → definitely mismatched
  if (savedIds.length !== currentIds.length && cartData.items?.length != 0 && currentIds.length > 0) {
    // put any value just to trigger mismatch logic
    mismatchedIds = [true];
  } else {
    // fallback to your existing original logic
    mismatchedIds = savedIds.filter((id) => {
      return !id || !currentIds.includes(id);
    });
  }
  if (cartData.items?.length === 0 && addAlreadyRun) {
    await fetch("/cart/clear.js", {
      method: "POST",
    });
    cartModified = true;
  }
  if ((mismatchedIds.length || mismatchedItems.length) && addAlreadyRun && !cartModified) {
    // 1️⃣ Clear the cart
    await fetch("/cart/clear.js", {
      method: "POST",
    });

    // 2️⃣ Re-add mismatched items
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: cartData?.items?.slice()?.reverse()?.map((item) => ({
          id: item.variant_id,
          quantity: item.quantity,
          properties: item.properties || {},
        })),
      }),
    });
    cartModified = true;
  }

  if (mismatchedItems.length) {
    cartData.items = [
      ...cartData.items,
      ...mismatchedItems.map((item) => ({
        variant_id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties || {},
      })),
    ];
  }
  // Restore line items only if cart is empty and saved data exists
  if (cartData?.items?.length && !addAlreadyRun && !cartModified) {
    // Collect all missing items first
    const missingItems = cartData.items
      //.filter((item) => !currentIds.includes(item.properties?._unique_id))
      .filter((item) => !currentIds.includes(item.variant_id))
      ?.slice()?.reverse()?.map((item) => ({
        id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties || {},
      }));
    // Add all missing items in one request
    if (missingItems.length > 0) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: missingItems }),
      });

      cartModified = true;
    }

    // Restore cart-level attributes
    if (cartData.attributes && Object.keys(cartData.attributes).length) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: cartData.attributes }),
      });
      cartModified = true;
    }

    // Restore note
    if (cartData.note) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: cartData.note }),
      });
      cartModified = true;
    }
    localStorage.setItem("customerCartChecked", true);
  }

  // Only refresh cart drawer if something changed
  if (cartModified) {
    try {
      const cart = await fetch("/cart.js").then((res) => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.json();
      });

      const [sections, updatedCart] = await Promise.all([
        fetch(getSectionsUrl()).then((res) => {
          if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
          return res.json();
        }),
        Promise.resolve(cart),
      ]);
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(
          {
            items: updatedCart.items,
            sections,
            total_price: updatedCart.total_price,
          },
          false
        );

        // 🔥 New addition: If cart-items section exists in DOM, refresh it
        let mainCartItems = document.getElementById('main-cart-items');
        if (mainCartItems) {
          fetch(`${routes.cart_url}?section_id=main-cart-items`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const targetElement = document.querySelector("cart-items");
              const sourceElement = html.querySelector("cart-items");

              const sourceQty = html?.querySelector('.js-contents');
              mainCartItems.querySelector('.js-contents').innerHTML = sourceQty.innerHTML;
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
              reinitializeCartScripts();
            })
            .catch((e) => {
              console.error(e);
            });
        }

        await updateCustomerCartMetafield();
        await cartRemoveButton();
      } else {
        console.error("cart-drawer element or renderContents method not found");
      }
    } catch (err) {
      console.error("❌ Failed to refresh cart:", err);
    }
  }
}


document.addEventListener("DOMContentLoaded", restoreCartFromCustomerMetafield);
